<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">Larval Identification</h1>
        <div class="pull-right">
          <!--<button class="pointer btn btn-lg btn-primary" v-on:click="form.showEdit({})">Create New</button>-->
        </div>
      </div>
    </div>

    <div class="panel">
      <search-fields :form="form" :fields="searchFieldsList"></search-fields>

      <loading :working="form.working()"></loading>

      <div class="panel-body" v-if="!form.working()">
        <div class="col-xs-12 table-responsive">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Sample #</th>
              <th>Site Name</th>
              <th>Location</th>
              <th>Mosquito Species</th>
              <th>Identified</th>
              <th>Work Status</th>
              <th width="170"></th>
            </tr>
            </thead>
            <tbody>

            <tr v-for="item in form.list">
              <td>{{ item.attributes.sampleNumber }}</td>
              <td>{{ item.attributes.siteName }}</td>
              <td>{{ item.attributes.location }}</td>
              <td>
                <div v-for="count in item.attributes.species">
                  {{ mosquitoName(count.mosquito) }} : {{ count.count }}
                </div>
              </td>
              <td>
                <span v-if="item.attributes.identifiedBy">By:</span> {{ item.attributes.identifiedBy }}<br>
                <span v-if="item.attributes.idDate">On:</span> {{ item.attributes.idDate | date }}<br>
              </td>
              <td>{{ item.attributes.workStatus }}</td>
              <td>
                <a class="pointer text-primary" v-on:click="showEdit(item)"><i class="fa fa-pencil mr-10"></i> Add Data</a><br>
                <router-link :to="{ name: 'data-larvicide-details', params: { id: item.attributes.larvicideId} }"><i class="fa fa-file-o mr-10"></i> Sample Details</router-link>
              </td>
            </tr>


            </tbody>
            <pager :form="form"></pager>

          </table>
        </div>
      </div>
    </div>

    <site-form :form="form"></site-form>

  </div>
</template>

<script>
  import LarvalIdentificationService from '@/services/LarvalIdentificationService';
  import Form from '@/utils/form';
  import loader from '@/utils/loader';
  import siteForm from '@/components/forms/larval_identification';
  import pager from '@/components/forms/pager';
  import searchFields from '@/components/search_fields';
  import loading from '@/components/loading';
  import store from '@/store';

  export default {
    name: 'larval_identification',

    components: {
      pager,
      siteForm,
      searchFields,
      loading
    },

    props: ['id'],

    data() {
      return {
        searchFieldsList: {'sample_number': 'Sample #', 'site': 'Site Name', 'location': 'Location'},
        form: new Form(
          LarvalIdentificationService,
          {

          })
      }
    },

    methods: {
      mosquitoName(id) {
        return this.$store.getters.mosquitoNameById(id)
      },
      showEdit(item) {
        this.form.data =  item.attributes;
        if (!this.form.data.species) {
          this.form.data.species = [];
        }
        this.form.showEdit({id: item.id});
      }
    },

    mounted() {
      loader.lookups()
        .then(() => {
          this.form.getList();
        });

      if (this.$props.id) {
        this.form.showEdit({});
        this.form.data.larvicideId = this.$props.id;
      }

    }

  }
</script>

<style lang="scss">

</style>